import React, { useState } from 'react';
import { Modal } from 'antd';
import { removeDocument, removeFolder } from '@gtintel/platform-api';
import { AbsoluteLoading } from '@gtintel/platform-atoms';
import ModalIcon from '../../atoms/Icons/ModalIcon';
import { CustomAlert } from '../../atoms/Modal/Alert/styles';
import ModalIconSection from '../../atoms/Modal/IconSection';
import ModalTitle from '../../atoms/Modal/Title';
export default function DeleteModal({
  documentId,
  isFile,
  isVisible,
  path,
  projectId,
  refreshFileList,
  setIsVisible
}) {
  const [msg, setMsg] = useState('');
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const handleCancel = () => {
    setIsVisible(false);
    setMsg('');
    setType('');
  };
  const handleOk = () => {
    setLoading(true);
    if (isFile) {
      removeDocument({
        id: documentId
      }).then(response => {
        setLoading(false);
        if (response) {
          setMsg('The file was deleted successfully');
          setType('success');
          refreshFileList();
          handleCancel();
        }
      }).catch(error => {
        if (error.data) {
          setMsg('You do not have permission to delete this file');
          setType('error');
          setLoading(false);
        }
      });
    } else {
      const formData = new FormData();
      formData.append('project_id', projectId.toString());
      formData.append('folder', path);
      removeFolder({
        data: formData
      }).then(response => {
        setLoading(false);
        if (response) {
          setMsg('The folder was deleted successfully');
          setType('success');
          refreshFileList();
          handleCancel();
        }
      }).catch(error => {
        if (error.data) {
          setMsg('You do not have permission to delete this folder');
          setType('error');
          setLoading(false);
        }
      });
    }
  };
  return <Modal visible={isVisible} closable keyboard onOk={handleOk} onCancel={handleCancel} okText="Confirm" data-testid="doc-remove-modal">
      <AbsoluteLoading isLoading={loading} />
      <ModalIconSection>
        <ModalIcon type="remove" />
        <ModalTitle>Remove {isFile ? 'Document' : 'Folder'}</ModalTitle>
        This {isFile ? 'document' : 'folder and the files inside'} will be
        deleted permanently
      </ModalIconSection>
      {type && <CustomAlert message={msg} type={type} showIcon closable />}
    </Modal>;
}